import { render, staticRenderFns } from "./EipRealtimeTextarea.vue?vue&type=template&id=56dea92c&scoped=true&"
import script from "./EipRealtimeTextarea.vue?vue&type=script&lang=js&"
export * from "./EipRealtimeTextarea.vue?vue&type=script&lang=js&"
import style0 from "./EipRealtimeTextarea.vue?vue&type=style&index=0&id=56dea92c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dea92c",
  null
  
)

export default component.exports